import { render, staticRenderFns } from "./deptTree.vue?vue&type=template&id=4116ff52&scoped=true"
import script from "./deptTree.vue?vue&type=script&lang=js"
export * from "./deptTree.vue?vue&type=script&lang=js"
import style0 from "./deptTree.vue?vue&type=style&index=0&id=4116ff52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4116ff52",
  null
  
)

export default component.exports